import {useTheme} from 'next-themes'
import {Toaster as Sonner} from 'sonner'
import View from './view'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({...props}: ToasterProps) => {
  return <View {...props} />
}

export default Toaster
